import { render, staticRenderFns } from "./SelectDoctypeStep.vue?vue&type=template&id=709b2a19&scoped=true&"
import script from "./SelectDoctypeStep.vue?vue&type=script&lang=js&"
export * from "./SelectDoctypeStep.vue?vue&type=script&lang=js&"
import style0 from "./SelectDoctypeStep.vue?vue&type=style&index=0&id=709b2a19&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "709b2a19",
  null
  
)

export default component.exports